import React, { useState, useEffect,useContext} from 'react';
import { useNavigate,useParams} from 'react-router-dom';
import Label from '../../../Components/Label';
import InputField from '../../../Components/InputField';
import Button from '../../../Components/Button';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { toast } from 'react-toastify';
import { SelectPicker } from 'rsuite';

import { GlobalContext } from '../../../GlobalContext';

const EditCompany = () => {

    const token = localStorage.getItem('token');

    const navigate = useNavigate();
    const { currentTab, setCurrentTab } = useContext(GlobalContext);

    useEffect(() => {
        setCurrentTab('Edit company information');
    });
    const { companyId } = useParams();

    const date = new Date();

    // Get year, month, and day
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');

    const formattedDate = `${year}-${month}-${day}`;

    const regionNames = [
        "Southeast Asia",
        "North America",
        "South America",
        "Europe",
        "Africa",
        "Oceania",
    ].map(
        item => ({ label: item, value: item })
    );

    const [companyData, setCompanyData] = useState({});

    useEffect(() => {
        const fetch = async () => {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }

            await axios.post(`${POCBaseUrl}/companys/getone`, { companyId:companyId },
                {
                    headers: {
                        "Content-Type": "application/json", // Specify content type
                        Authorization: `Bearer ${token}`, // Include the token
                    },
                }
            )
                .then(response => {
                    // console.log('agentData', response.data.data);

                    setCompanyData(response.data.data);
                })
                .catch(error => {
                    console.error("There was an error fetching the customer data!", error);
                });
        }
        fetch();
    }, []);

    const handleCompanyChange = (e) => {
        setCompanyData({
            ...companyData,
            [e.target.name]: e.target.value,
        });
    };
    const handleRegionChange = (value) => {
        setCompanyData((prevData) => ({
                ...prevData,
                region: value, // Update the country in the state
        }));
    };

    //---reset password-------------
    const [resetPasswordOpen, setResetPasswordOpen] = useState(false);
    const [userPassword, setUserPassword] = useState({
        newPassword :'',
        confirmPassword: ''
    });
    const handlePasswordChange = (e) => {
        setUserPassword({
            ...userPassword,
            [e.target.name]: e.target.value,
        });
    };

    const handleResetPassword = async() => {

        try {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }
            if(userPassword.newPassword === '' || userPassword.newPassword !== userPassword.confirmPassword) {
                toast.warn("The new password and confirmation do not match!", {
                    className: 'centered-toast-warn',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    pauseOnFocusLoss: true
                  });
                return;
            }

            const response = await axios.post(`${POCBaseUrl}/companys/resetpassword`, {companyId: companyId, passwordData: userPassword.newPassword},
                {
                    headers: {
                      "Content-Type": "application/json", // Specify content type
                      Token: token,// Include the token
                    },
                  }
            )
            .then(response=>{
                toast.success('Password updated successfully!', {
                    className: 'centered-toast-success',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    // draggable: true,
                    pauseOnFocusLoss: true
                  });
                setResetPasswordOpen(false);
                setUserPassword({});
            })
            .catch(error=>{
                console.error("There was an error", error);
            })
        } catch (error) {
            console.error('Error sending message:', error);
        }

    };

    const gotoCompanyList = () => {
        navigate(`/companylist`); // Use navigate for routing
    };

    const handleCompanyUpdate = async() => {

        try {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }

            const response = await axios.post(`${POCBaseUrl}/companys/edit`, {companyId,companyData},
                {
                    headers: {
                      "Content-Type": "application/json", // Specify content type
                      Token: token, // Include the token
                    },
                  }
            );
            if(response.data.success) {
                toast.success("Updated successfully!", {
                    className: 'centered-toast-success',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                  });
                navigate(`/companylist`);
            } else {
                toast.warn("Update failed!", {
                    className: 'centered-toast-warn',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    pauseOnFocusLoss: true
                });
            }

        } catch (error) {
            console.error('Error sending message:', error);
        }

    };

    return (
        <>
            <div className="flex mt-2.5 bg-[#f0f0f0] rounded-[5px]" style={{ fontFamily: 'Liberation Serif' }}>
                <div className="ml-[25px] mt-2.5 pr-[40px]">
                    <div className='mb-[22px] flex'>
                        <div className='w-[150px]'>
                            <Label text={'Name'} className={'!font-medium'}/>
                        </div>
                        <div className='relative text-[14px] leading-[40px]'>
                            <InputField name = {'name'} value={companyData.name || ''} onChange={handleCompanyChange} placeholder={'Please enter agent name'} />
                        </div>
                        <span className='h-[24px] mt-[10px] text-[#fc3b3e] ml-[10px] text-[14px]'>Contains 4-20 numbers, letters, underlines, but not starts with underline</span>
                    </div>
                    <div className='mb-[22px] flex'>
                        <div className='w-[150px]'>
                            <Label text={'Contacts'} className={'!font-medium'}/>
                        </div>
                        <div className='relative text-[14px] leading-[40px]'>
                            <InputField name = {'contacts'} value={companyData.contacts || ''} onChange={handleCompanyChange} placeholder={'Please input contact person'} />
                        </div>
                        <span className='h-[24px] mt-[10px] text-[#fc3b3e] ml-[10px] text-[14px]'>Contains 2-10 numbers, letters, underlines, but not starts with underline</span>
                    </div>
                    <div className='mb-[22px] flex'>
                        <div className='w-[150px]'>
                            <Label text={'Region'} className={'!font-medium'}/>
                        </div>
                        <div className='relative text-[14px] leading-[40px]'>
                            <SelectPicker data={regionNames} value={companyData.region || ''} disabled={true} onChange={handleRegionChange} appearance="default" placeholder="" className="w-[360px] !h-[40px]" />
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <div className='w-[150px]'>
                            <Label text={'Account'} className={'!font-medium'}/>
                        </div>
                        <div className='relative text-[14px] leading-[40px]'>
                        <InputField name = {'account'} className={'!text-[#606266]'} value={companyData.account || ''} onChange={handleCompanyChange} disabled={true} placeholder={'Please input contact person'} />
                        </div>
                        <span className='h-[24px] mt-[10px] text-[#fc3b3e] ml-[10px] text-[14px]'>Please select region</span>
                    </div>
                    <div className='mb-[22px] flex'>
                        <div className='w-[150px]'>
                            <Label text={'Detailed address'} className={'!font-medium'}/>
                        </div>
                        <div className='relative text-[14px] leading-[40px]'>
                            <InputField name = {'detailed_address'} value={companyData.detailed_address || ''} onChange={handleCompanyChange} placeholder={'Please enter detailed address'} />
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <Label text={'password'} className={'!font-medium !w-[150px]'}/>
                        <div className='relative text-[14px] leading-[40px] !w-[272px]'>
                            <InputField type={'password'} placeholder={'******'} className='!w-[272px]' />
                        </div>
                        <div>
                            <Button children={'Reset'} onClick={()=> setResetPasswordOpen(true)}/>
                        </div>
                        <span className='h-[24px] mt-[10px] text-[#fc3b3e] ml-[10px] text-[14px]'>Constains 6-16 letters or numbers</span>
                    </div>
                </div>
            </div>
            <div className='flex mt-2.5 bg-[#f0f0f0]' style={{ fontFamily: 'Liberation Serif' }}>
                <button onClick={handleCompanyUpdate} className='inline-block mt-2.5 mb-2.5 ml-44 bg-[#2776c3] py-2 px-16 rounded text-white cursor-pointer'>
                    Update
                </button>
                <button onClick={gotoCompanyList} className='inline-block mt-2.5 mb-2.5 ml-3 bg-[#2776c3] py-2 px-16 rounded text-white cursor-pointer'>
                    Return to the list
                </button>
            </div>
            {resetPasswordOpen && (
                <div className="fixed inset-0 p-4 flex flex-wrap justify-center items-center w-full h-full z-[1000] before:fixed before:inset-0 before:w-full before:h-full before:bg-[rgba(0,0,0,0.5)] overflow-auto font-[sans-serif]" style={{ fontFamily: 'Liberation Serif' }}>
                    <div className="w-[600px] bg-white shadow-lg rounded-lg p-6 relative">
                        <div className="flex items-center pb-3 border-b border-gray-300">
                            <h3 className="text-xl flex-1 text-center text-[#2776c3]">Reset login password</h3>
                            <svg
                                className="w-3 ml-2 cursor-pointer shrink-0 fill-gray-400 hover:fill-red-500"
                                viewBox="0 0 320.591 320.591"
                                onClick={()=> setResetPasswordOpen(false)} // Close modal on click
                            >
                                <path
                                    d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z"
                                />
                                <path
                                    d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z"
                                />
                            </svg>
                        </div>
        
                        <div className="pt-5 flex justify-center items-center">
                            <span className='text-[#5a5655] w-[150px]'>New password:</span>
                            <InputField name = {'newPassword'} value={userPassword.newPassword || ''} onChange={handlePasswordChange} type={'password'} placeholder={'Please enter the new password (6-16 characters)'} />
                        </div>
                        <div className="pt-5 flex justify-center items-center">
                            <span className='text-[#5a5655] w-[150px]'>Confirm password:</span>
                            <InputField name = {'confirmPassword'} value={userPassword.confirmPassword || ''} onChange={handlePasswordChange} type={'password'} placeholder={'Please confirm the new password (6-16 characters)'} />
                        </div>
        
                        <div className="pt-10 flex justify-center gap-4" style={{ fontFamily: 'Liberation Serif' }}>
                            <button
                                type="button"
                                className="w-[320px] h-[36px] rounded-lg text-[white] text-sm border-none outline-none tracking-wide bg-[#2776c3]"
                                onClick={handleResetPassword} // Close modal on click
                            >
                                Yes
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default EditCompany;